<template>
  <div class="prorab-k2sv-task-confirm tw-max-w-[480px]">
    <p class="tw-text-sm tw-text-grey-8 tw-mb-4">
      Скачайте КС2В, проверьте документ. После успешного скачивания станет доступна кнопка «Согласовать» — тогда сотрудники смогут продолжить подписание.
    </p>
    <div class="tw-flex tw-flex-col tw-gap-3">
      <CustomButton
        outline
        color="primary"
        :loading="downloading"
        :disable="!canDownload"
        @click="onDownload"
      >
        <span class="tw-inline-flex tw-items-center tw-justify-center tw-gap-2">
          <span>Скачать документ</span>
          <q-icon name="download" size="18px" aria-hidden="true" />
        </span>
      </CustomButton>
      <p
        v-if="canDownload && !hasDownloadedDocument"
        class="tw-text-xs tw-text-orange-9 tw-m-0"
      >
        Сначала скачайте документ, затем нажмите «Согласовать».
      </p>
      <p
        v-else-if="hasDownloadedDocument"
        class="tw-text-xs text-positive tw-m-0 tw-flex tw-items-center tw-gap-1"
      >
        <q-icon name="check_circle" size="14px" />
        Документ скачан — можно согласовать.
      </p>
      <div class="tw-flex tw-justify-end tw-gap-2">
        <CustomButton outline :height="36" @click="onCancel">
          Отмена
        </CustomButton>
        <CustomButton
          color="primary"
          :height="36"
          :loading="approving"
          :disable="!canAgree"
          @click="onApprove"
        >
          Согласовать
        </CustomButton>
      </div>
    </div>
  </div>
</template>

<script>
import CustomButton from '@/components/common/CustomButton.vue'
import { useCustomSnackbar } from '@/_helpers/hooks/useCustomSnackbar'
import { downloadFile } from '@/services'
import { setEmployeeTaskIsDone } from '@/views/EmployeeTasks/services'

export default {
  name: 'ProrabK2svTaskConfirm',
  components: { CustomButton },
  props: {
    data: { type: Object, required: true },
    closeModal: { type: Function, required: true },
  },
  setup() {
    const { showErrorSnackbar } = useCustomSnackbar()
    return { showErrorSnackbar }
  },
  data() {
    return {
      downloading: false,
      approving: false,
      hasDownloadedDocument: false,
    }
  },
  computed: {
    canAgree() {
      if (!this.canDownload) return false
      return this.hasDownloadedDocument
    },
    canDownload() {
      return !!this.data?.master_url
    },
    documentParams() {
      const d = this.data || {}
      return {
        resident_id: d.resident_id,
        project_type_id: d.project_type_id,
        project_entrance_id: d.project_entrance_id,
        project_id: d.project_id,
        sbs_project_id: d.sbs_project_id,
      }
    },
  },
  methods: {
    onCancel() {
      this.closeModal()
    },
    async onDownload() {
      if (!this.canDownload || this.downloading) return
      this.downloading = true
      this.hasDownloadedDocument = false
      try {
        const titleBase =
          this.data?.floor_map_document_type_name || 'КС2В'
        const title = `${titleBase}${
          this.data?.document_date ? ` - ${this.data.document_date}` : ''
        }`
        const ok = await downloadFile(
          this.data.master_url,
          title,
          { ...this.documentParams },
          this.data?.file_ext || 'pdf',
          'get',
          false
        )
        if (ok) {
          this.hasDownloadedDocument = true
        }
      } finally {
        this.downloading = false
      }
    },
    async onApprove() {
      const id = this.data?.employee_task_id
      if (!id || this.approving) return
      if (!this.canAgree) {
        if (!this.canDownload) {
          this.showErrorSnackbar('Нет ссылки для скачивания документа')
        } else {
          this.showErrorSnackbar('Сначала скачайте документ')
        }
        return
      }
      this.approving = true
      const res = await setEmployeeTaskIsDone(id, true)
      this.approving = false
      if (!res) {
        this.showErrorSnackbar('Не удалось отметить задачу выполненной')
        return
      }
      if (typeof this.data?.onSuccess === 'function') {
        this.data.onSuccess()
      }
      this.closeModal()
    },
  },
}
</script>
